export default __webpack_public_path__ + "static/media/ordBlueSearch.7f7e2897.svg";